import type { PrimarySelection } from '../types/filters';
import {
  getPrimarySelectionMatchKey,
  initializeSelections,
} from '../utils/primaryFilterUtils';

// TODO: pass in the limit to clamp the active count
export function reconcilePageSelections(
  currentPage: PrimarySelection[],
  newSource: PrimarySelection[],
  defaultActiveCount: number
): PrimarySelection[] {
  // If there's no current page state, it's a first visit. Initialize from the source.
  if (currentPage.length === 0) {
    return initializeSelections(newSource, defaultActiveCount);
  }

  // If we have current page state, reconcile.
  // The master list of available selections comes from `newSource`.
  const masterList = newSource.map((sourceItem) => ({
    ...sourceItem,
    isActive: false, // Start with all inactive
  }));

  // Match by level-qualified leaf id (same as `updatePrimarySelections`) so a
  // company/geo/role keeps its active chip when the tree rewrites compound
  // paths (e.g. Reference API vs selection-list shapes).
  const activeMatchKeys = new Set(
    currentPage
      .filter((s) => s.isActive)
      .map((s) => getPrimarySelectionMatchKey(s))
  );

  // Apply the 'active' status from the last visit to the master list
  let reconciled = masterList.map((item) =>
    activeMatchKeys.has(getPrimarySelectionMatchKey(item))
      ? { ...item, isActive: true }
      : item
  );

  // Final check: if after reconciliation no items are active (e.g., all active items from the last visit
  // were removed from the master list), then re-initialize to avoid a state with no active items.
  const hasActiveSelection = reconciled.some((s) => s.isActive);
  if (!hasActiveSelection) {
    reconciled = initializeSelections(reconciled, defaultActiveCount);
  }

  return reconciled;
}
